import React from 'react';

interface IconProps {
  width?: number;
  height?: number;
  className?: string;
}

const iconStyle = {
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 2,
  strokeLinecap: 'round' as const,
  strokeLinejoin: 'round' as const,
};

export const NewIcon: React.FC<IconProps> = ({ width = 20, height = 20, className }) => (
  <svg width={width} height={height} viewBox="0 0 24 24" className={className} {...iconStyle}>
    <circle cx="12" cy="12" r="10"></circle>
    <line x1="12" y1="8" x2="12" y2="16"></line>
    <line x1="8" y1="12" x2="16" y2="12"></line>
  </svg>
);

export const PhoneIcon: React.FC<IconProps> = ({ width = 20, height = 20, className }) => (
  <svg width={width} height={height} viewBox="0 0 24 24" className={className} {...iconStyle}>
    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>
  </svg>
);

export const CheckCircleIcon: React.FC<IconProps> = ({ width = 20, height = 20, className }) => (
  <svg width={width} height={height} viewBox="0 0 24 24" className={className} {...iconStyle}>
    <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
    <polyline points="22 4 12 14.01 9 11.01"></polyline>
  </svg>
);

export const SettingsIcon: React.FC<IconProps> = ({ width = 20, height = 20, className }) => (
  <svg width={width} height={height} viewBox="0 0 24 24" className={className} {...iconStyle}>
    <path d="M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"></path>
    <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"></path>
  </svg>
);

export const HandshakeIcon: React.FC<IconProps> = ({ width = 20, height = 20, className }) => (
  <svg width={width} height={height} viewBox="0 0 24 24" className={className} {...iconStyle}>
    <path d="M11 12h2a2 2 0 1 0 0-4h-3c-.6 0-1.1.2-1.4.6L3 14"></path>
    <path d="M7 18h1a2 2 0 0 0 2-2v-4.5"></path>
    <path d="M13 18h1a2 2 0 0 0 2-2v-4.5"></path>
    <path d="M21 12h-2a2 2 0 1 1 0-4h3c-.6 0-1.1.2-1.4.6L18 8"></path>
    <path d="M21 18h-2a2 2 0 0 1-2-2v-4.5"></path>
    <path d="M15 18h-1a2 2 0 0 1-2-2v-4.5"></path>
  </svg>
);

export const AwardIcon: React.FC<IconProps> = ({ width = 20, height = 20, className }) => (
  <svg width={width} height={height} viewBox="0 0 24 24" className={className} {...iconStyle}>
    <circle cx="12" cy="8" r="7"></circle>
    <polyline points="8.21 13.89 7 23 12 20 17 23 15.79 13.88"></polyline>
  </svg>
);

export const XCircleIcon: React.FC<IconProps> = ({ width = 20, height = 20, className }) => (
  <svg width={width} height={height} viewBox="0 0 24 24" className={className} {...iconStyle}>
    <circle cx="12" cy="12" r="10"></circle>
    <line x1="15" y1="9" x2="9" y2="15"></line>
    <line x1="9" y1="9" x2="15" y2="15"></line>
  </svg>
);

export const UserIcon: React.FC<IconProps> = ({ width = 20, height = 20, className }) => (
  <svg width={width} height={height} viewBox="0 0 24 24" className={className} {...iconStyle}>
    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
    <circle cx="12" cy="7" r="4"></circle>
  </svg>
);

export const UsersIcon: React.FC<IconProps> = ({ width = 20, height = 20, className }) => (
  <svg width={width} height={height} viewBox="0 0 24 24" className={className} {...iconStyle}>
    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
    <circle cx="9" cy="7" r="4"></circle>
    <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
    <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
  </svg>
);

export const ZapIcon: React.FC<IconProps> = ({ width = 20, height = 20, className }) => (
  <svg width={width} height={height} viewBox="0 0 24 24" className={className} {...iconStyle}>
    <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"></polygon>
  </svg>
);

export const ClipboardIcon: React.FC<IconProps> = ({ width = 20, height = 20, className }) => (
  <svg width={width} height={height} viewBox="0 0 24 24" className={className} {...iconStyle}>
    <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"></path>
    <rect x="8" y="2" width="8" height="4" rx="1" ry="1"></rect>
  </svg>
);

export const AlertTriangleIcon: React.FC<IconProps> = ({ width = 20, height = 20, className }) => (
  <svg width={width} height={height} viewBox="0 0 24 24" className={className} {...iconStyle}>
    <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"></path>
    <line x1="12" y1="9" x2="12" y2="13"></line>
    <line x1="12" y1="17" x2="12.01" y2="17"></line>
  </svg>
);

export const FlameIcon: React.FC<IconProps> = ({ width = 20, height = 20, className }) => (
  <svg width={width} height={height} viewBox="0 0 24 24" className={className} {...iconStyle}>
    <path d="M8.5 14.5A2.5 2.5 0 0 0 11 12c0-1.38-.5-2-1-3-1.072-2.143-.224-4.054 2-6 .5 2.5 2 4.9 4 6.5 2 1.6 3 3.5 3 5.5a7 7 0 1 1-14 0c0-1.153.433-2.294 1-3a2.5 2.5 0 0 0 2.5 2.5z"></path>
  </svg>
);

export const MessageCircleIcon: React.FC<IconProps> = ({ width = 20, height = 20, className }) => (
  <svg width={width} height={height} viewBox="0 0 24 24" className={className} {...iconStyle}>
    <path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"></path>
  </svg>
);

/** Icono de sobre (correo/email) */
export const EnvelopeIcon: React.FC<IconProps> = ({ width = 20, height = 20, className }) => (
  <svg width={width} height={height} viewBox="0 0 24 24" className={className} {...iconStyle}>
    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
    <polyline points="22,6 12,13 2,6"></polyline>
  </svg>
);

export const FileTextIcon: React.FC<IconProps> = ({ width = 20, height = 20, className }) => (
  <svg width={width} height={height} viewBox="0 0 24 24" className={className} {...iconStyle}>
    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
    <polyline points="14 2 14 8 20 8"></polyline>
    <line x1="16" y1="13" x2="8" y2="13"></line>
    <line x1="16" y1="17" x2="8" y2="17"></line>
    <polyline points="10 9 9 9 8 9"></polyline>
  </svg>
);

export const BuildingIcon: React.FC<IconProps> = ({ width = 20, height = 20, className }) => (
  <svg width={width} height={height} viewBox="0 0 24 24" className={className} {...iconStyle}>
    <path d="M3 21h18"></path>
    <path d="M5 21V7l8-4v18"></path>
    <path d="M19 21V11l-6-4"></path>
    <line x1="9" y1="9" x2="9" y2="9"></line>
    <line x1="9" y1="12" x2="9" y2="12"></line>
    <line x1="9" y1="15" x2="9" y2="15"></line>
    <line x1="9" y1="18" x2="9" y2="18"></line>
  </svg>
);

export const MicIcon: React.FC<IconProps> = ({ width = 20, height = 20, className }) => (
  <svg width={width} height={height} viewBox="0 0 24 24" className={className} {...iconStyle}>
    <path d="M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z"></path>
    <path d="M19 10v2a7 7 0 0 1-14 0v-2"></path>
    <line x1="12" y1="19" x2="12" y2="23"></line>
    <line x1="8" y1="23" x2="16" y2="23"></line>
  </svg>
);

export const CalendarIcon: React.FC<IconProps> = ({ width = 20, height = 20, className }) => (
  <svg width={width} height={height} viewBox="0 0 24 24" className={className} {...iconStyle}>
    <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
    <line x1="16" y1="2" x2="16" y2="6"></line>
    <line x1="8" y1="2" x2="8" y2="6"></line>
    <line x1="3" y1="10" x2="21" y2="10"></line>
  </svg>
);

export const BookIcon: React.FC<IconProps> = ({ width = 20, height = 20, className }) => (
  <svg width={width} height={height} viewBox="0 0 24 24" className={className} {...iconStyle}>
    <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"></path>
    <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"></path>
  </svg>
);

export const CheckIcon: React.FC<IconProps> = ({ width = 20, height = 20, className }) => (
  <svg width={width} height={height} viewBox="0 0 24 24" className={className} {...iconStyle}>
    <polyline points="20 6 9 17 4 12"></polyline>
  </svg>
);

export const XIcon: React.FC<IconProps> = ({ width = 20, height = 20, className }) => (
  <svg width={width} height={height} viewBox="0 0 24 24" className={className} {...iconStyle}>
    <line x1="18" y1="6" x2="6" y2="18"></line>
    <line x1="6" y1="6" x2="18" y2="18"></line>
  </svg>
);

export const CircleIcon: React.FC<IconProps & { color?: string }> = ({ width = 20, height = 20, className, color }) => (
  <svg width={width} height={height} viewBox="0 0 24 24" className={className}>
    <circle cx="12" cy="12" r="10" fill={color || 'currentColor'}></circle>
  </svg>
);

export const ChevronDownIcon: React.FC<IconProps> = ({ width = 20, height = 20, className }) => (
  <svg width={width} height={height} viewBox="0 0 24 24" className={className} {...iconStyle}>
    <polyline points="6 9 12 15 18 9"></polyline>
  </svg>
);

export const ChevronUpIcon: React.FC<IconProps> = ({ width = 20, height = 20, className }) => (
  <svg width={width} height={height} viewBox="0 0 24 24" className={className} {...iconStyle}>
    <polyline points="18 15 12 9 6 15"></polyline>
  </svg>
);

export const ClockIcon: React.FC<IconProps> = ({ width = 20, height = 20, className }) => (
  <svg width={width} height={height} viewBox="0 0 24 24" className={className} {...iconStyle}>
    <circle cx="12" cy="12" r="10"></circle>
    <polyline points="12 6 12 12 16 14"></polyline>
  </svg>
);

export const BarChartIcon: React.FC<IconProps> = ({ width = 20, height = 20, className }) => (
  <svg width={width} height={height} viewBox="0 0 24 24" className={className} {...iconStyle}>
    <line x1="18" y1="20" x2="18" y2="10"></line>
    <line x1="12" y1="20" x2="12" y2="4"></line>
    <line x1="6" y1="20" x2="6" y2="14"></line>
  </svg>
);

export const HomeIcon: React.FC<IconProps> = ({ width = 20, height = 20, className }) => (
  <svg width={width} height={height} viewBox="0 0 24 24" className={className} {...iconStyle}>
    <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
    <polyline points="9 22 9 12 15 12 15 22"></polyline>
  </svg>
);

export const SearchIcon: React.FC<IconProps> = ({ width = 20, height = 20, className }) => (
  <svg width={width} height={height} viewBox="0 0 24 24" className={className} {...iconStyle}>
    <circle cx="11" cy="11" r="8"></circle>
    <path d="m21 21-4.35-4.35"></path>
  </svg>
);

export const RefreshIcon: React.FC<IconProps> = ({ width = 20, height = 20, className }) => (
  <svg width={width} height={height} viewBox="0 0 24 24" className={className} {...iconStyle}>
    <polyline points="23 4 23 10 17 10"></polyline>
    <polyline points="1 20 1 14 7 14"></polyline>
    <path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"></path>
  </svg>
);

export const TagIcon: React.FC<IconProps> = ({ width = 20, height = 20, className }) => (
  <svg width={width} height={height} viewBox="0 0 24 24" className={className} {...iconStyle}>
    <path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"></path>
    <circle cx="7" cy="7" r="1.5"></circle>
  </svg>
);

export const PlusIcon: React.FC<IconProps> = ({ width = 20, height = 20, className }) => (
  <svg width={width} height={height} viewBox="0 0 24 24" className={className} {...iconStyle}>
    <line x1="12" y1="5" x2="12" y2="19"></line>
    <line x1="5" y1="12" x2="19" y2="12"></line>
  </svg>
);

export const TrashIcon: React.FC<IconProps> = ({ width = 20, height = 20, className }) => (
  <svg width={width} height={height} viewBox="0 0 24 24" className={className} {...iconStyle}>
    <polyline points="3 6 5 6 21 6"></polyline>
    <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
    <line x1="10" y1="11" x2="10" y2="17"></line>
    <line x1="14" y1="11" x2="14" y2="17"></line>
  </svg>
);

export const EditIcon: React.FC<IconProps> = ({ width = 20, height = 20, className }) => (
  <svg width={width} height={height} viewBox="0 0 24 24" className={className} {...iconStyle}>
    <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path>
    <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path>
  </svg>
);

export const MapPinIcon: React.FC<IconProps> = ({ width = 20, height = 20, className }) => (
  <svg width={width} height={height} viewBox="0 0 24 24" className={className} {...iconStyle}>
    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
    <circle cx="12" cy="10" r="3"></circle>
  </svg>
);

/** Icono tipo WhatsApp (burbuja de chat) */
export const WhatsAppIcon: React.FC<IconProps> = ({ width = 20, height = 20, className }) => (
  <svg width={width} height={height} viewBox="0 0 24 24" className={className} fill="currentColor" aria-hidden="true">
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
  </svg>
);

/** Logo LinkedIn (marca oficial simplificada) */
export const LinkedInIcon: React.FC<IconProps> = ({ width = 20, height = 20, className }) => (
  <svg width={width} height={height} viewBox="0 0 24 24" className={className} fill="currentColor" aria-hidden="true">
    <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
  </svg>
);

/** Icono de filtros (sliders / líneas) */
export const FilterIcon: React.FC<IconProps> = ({ width = 20, height = 20, className }) => (
  <svg width={width} height={height} viewBox="0 0 24 24" className={className} {...iconStyle}>
    <line x1="4" y1="21" x2="4" y2="14"></line>
    <line x1="4" y1="10" x2="4" y2="3"></line>
    <line x1="12" y1="21" x2="12" y2="12"></line>
    <line x1="12" y1="8" x2="12" y2="3"></line>
    <line x1="20" y1="21" x2="20" y2="16"></line>
    <line x1="20" y1="12" x2="20" y2="3"></line>
    <line x1="1" y1="14" x2="7" y2="14"></line>
    <line x1="9" y1="8" x2="15" y2="8"></line>
    <line x1="17" y1="16" x2="23" y2="16"></line>
  </svg>
);
